import constants from 'src/constants';
import frontBookConfig from 'src/components/appointments/Book/config.front';

const userStatuses = constants.general.userStatus;

/**
 * Booking config for the admin app.
 * Same shape as the front config. Only the real differences are listed here.
 */
const adminBookConfig = {
  ...frontBookConfig,

  modelId: 'AdminBookModel',
  accountModelId: 'AccountsModel',

  // admin only stores the profile, it never switches account
  profileHandler: 'handleProfile',

  api: {
    ...frontBookConfig.api,
    appointmentDetail: 'admin/appointment/detail',
    createAppointment: 'admin/appointment/create',
    createAppointmentOffice: 'admin/appointment/create/office',
    getSlots: 'schedule/list', // admin also sees booked slots
    rescheduleAppointment: 'admin/appointment/update',
    checkSlotAvailable: 'admin/appointment/checkSlotAvailable',
    invitePatient: 'patient/invite'
  },

  doctorList: {
    url: 'admin/doctor/list',
    statusList: [
      userStatuses.approved,
      userStatuses.enabled,
      userStatuses.disabled,
      userStatuses.active
    ]
  },

  // admin invite api returns the patient directly
  parseInviteResult: (data) => data,

  roleBasedFlows: false,
  payNowEnabled: false,
  scrollCalendarOnLoad: true,
  finishWithBack: true,

  getSlotCheckPartnerId: ({ doctorId }) => doctorId,
  getHospitalOwnerId: ({ doctorId }) => doctorId,
  getRescheduleExtraParams: ({ appointment }) => ({ doctorId: appointment.doctorId })
};

export default adminBookConfig;
